import { classifyLeaseAreas, dateOnly } from "../../../shared/leaseAreaBasis.js";

// Presentation grouping only; never use these rows to calculate footprint or rent.
export function leaseAreaPresentation(lease, asOf = new Date()) {
  const recorded = Array.isArray(lease?.areas) ? lease.areas : [];
  const { areas } = classifyLeaseAreas({ areas: recorded.filter((area) => !area.isLegacyArea) }, asOf);
  const groups = [
    { status: "active", label: "Active", areas: areas.filter((area) => area.status === "active") },
    { status: "expired", label: "Expired", areas: areas.filter((area) => area.status === "expired")
      .sort((a, b) => (dateOnly(b.expirationDate) || "").localeCompare(dateOnly(a.expirationDate) || "")) },
    { status: "upcoming", label: "Upcoming", areas: areas.filter((area) => area.status === "upcoming") },
    { status: "in_build", label: "In Build", areas: areas.filter((area) => area.status === "in_build") },
    { status: "unknown", label: "Legacy area details", areas: recorded.filter((area) => area.isLegacyArea) },
  ].filter((group) => group.areas.length);
  const active = areas.filter((area) => area.status === "active");
  const expiredCount = areas.filter((area) => area.status === "expired").length;
  return { groups, active, expiredCount, activeCount: active.length,
    countLabel: `${active.length} active ${active.length === 1 ? "area" : "areas"}` };
}

export function areaLifecycleLabel(area) {
  if (area.status === "expired") {
    const date = dateOnly(area.expirationDate);
    const parsed = date ? new Date(`${date}T00:00:00Z`) : null;
    const month = parsed && !Number.isNaN(parsed.getTime())
      ? parsed.toLocaleDateString("en-US", { month: "short", year: "numeric", timeZone: "UTC" }) : null;
    return month ? `Expired - ${month}` : "Expired";
  }
  return area.status === "in_build" ? "In Build" : area.status === "upcoming" ? "Upcoming" : null;
}
